/**
 * Created by aleco on 03/14/2018.
 */

import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import { FileUploader } from "ng2-file-upload";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { CsvMappingFields } from "../../../../entities/csvMappingFields";
import { ServiceService} from "../../../../services/service.service";
import { Service} from "../../../../entities/service";
import { SharedService } from 'src/app/services/sharedService';
import {ExternalApiGatewayService} from "../../../../services/external-api-gateway.service";
import {CurrencyService} from "../../../../services/currency.service";
import { SpecialColumnsEditorComponent } from "../special-columns-editor/special-columns-editor.component";

export enum FetchType {
  CSV_UPLOAD = 'CSV-UPLOAD',
  API_GATEWAY = 'API-GATEWAY',
}
@Component({
  selector: '<ntr-csv-upload>',
  templateUrl: './csv-upload.component.html',
  styleUrls: ['./csv-upload.component.css']
})
export class CsvUploadComponent implements OnInit {
  @ViewChild('fileUpload', {static: false}) selectedFile: any;
  @ViewChild(SpecialColumnsEditorComponent) specialEditor: SpecialColumnsEditorComponent;
  errorMessage: string;
  @ViewChild('informationTemplate', {static: false})
  private informationTemplate: TemplateRef<any>;
  modalRef: BsModalRef;
  @Input() modal: BsModalRef;
  dataRows: string[];
  @Input()
  mappingObjects = [];
  mappingDropdown = new CsvMappingFields().dropDownList;
  conversionCodes: string[] = [];
  public uploader: FileUploader;
  @Input()
  formatName: string;
  @Input()
  fileFormat: object;
  @Input()
  serviceId: any;
  @Input()
  service: Service;
  @Output() dataFormatsAdded = new EventEmitter();
  @Input()
  hasHeader: boolean;
  dateTypeIsSelected: boolean;
  separators = [",",";"]
  @Input()
  separator
  @Input()
  fetchType = FetchType.CSV_UPLOAD
  @Input()
  externalApiGateway
  @Input()
  apiGateway
  @Input()
  autoRefetch: boolean
  @Input()
  jobDays: number
  @Input()
  splitByYear = false;
  @Input()
  yearDateField: string;
  @Input()
  flux = false;
  @Input()
  specialColumns: any[] = [];
  @Input()
  // FetchType: any;
  protected apiGateways: any
  fetching = false

  constructor(private serviceService: ServiceService,
              private modalService: BsModalService,
              private sharedService: SharedService,
              private currencyService: CurrencyService,
              private externalApiGatewayService: ExternalApiGatewayService) {
    this.sharedService.changeFileFormat.subscribe(fileFormat => {
      this.formatName = fileFormat.name
      this.hasHeader = fileFormat.hasHeader
      this.separator = fileFormat.separator
      this.splitByYear = !!fileFormat.splitByYear
      this.yearDateField = fileFormat.yearDateField
      this.flux = !!fileFormat.flux
      this.specialColumns = fileFormat.specialColumns ? JSON.parse(JSON.stringify(fileFormat.specialColumns)) : []
    })
    this.uploader = new FileUploader({url: this.sharedService.apiUrl('upload')});
    this.uploader.onAfterAddingFile = (fileItem) => {
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        if (this.uploader.queue.length > 1)
          this.uploader.queue.shift();
        this.fileFormat = null;
        this.dataRows = (fileReader.result as string).split('\n').slice(0, 5);
        this.mappingObjects = [];
        this.dataRows.slice(0, 1)[0].split(this.separator).forEach((item, index) => {
          this.mappingObjects.push({"column": index, "name": '', "alias": '', "description": ''})
        });
      }
      fileReader.readAsText(fileItem._file, "ISO-8859-1");
    }
    this.externalApiGatewayService.getList$().subscribe(list => {
      this.apiGateways = list
    })
  }

  ngOnInit(): void {
    this.currencyService.getConversionCodes().subscribe(res => {
      this.conversionCodes = (res && res.codes) || [];
    });
  }

  get dateFields(): any[] {
    const objs = (this.fileFormat && this.fileFormat['mappingObjects'])
      ? this.fileFormat['mappingObjects']
      : this.mappingObjects;
    return (objs || []).filter(mo => (String(mo?.type) === '4' || String(mo?.type) === '11') && mo?.name);
  }

  get visibleMappingObjects(): any[] {
    return ((this.fileFormat && this.fileFormat['mappingObjects']) || []).filter(mo => !mo?.flux && !mo?.special);
  }

  get sourceColumns(): any[] {
    const objs = (this.fileFormat && this.fileFormat['mappingObjects'])
      ? this.fileFormat['mappingObjects']
      : this.mappingObjects;
    return objs || [];
  }

  onChange(type, index) {
    this.mappingObjects[index].type = type;
    if (String(type) !== '5' && this.mappingObjects[index]['currencyCode'])
      delete this.mappingObjects[index]['currencyCode'];
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-lg'});

  }

  closeModal(template: TemplateRef<any>) {
    this.modalRef.hide();
  }

  apply() {
    if (this.specialEditor && !this.specialEditor.validate()) {
      return;
    }
    let sampleData: any[];
    let fields: any[];
    if (this.dataRows != null) {
      sampleData = [];
      if (this.fetchType == FetchType.CSV_UPLOAD) {
        for (let row of this.dataRows) {
          let rowData = row.split(this.separator);
          let rowArray = [];
          for (let rd of rowData) {
            rowArray.push(rd)
          }
          sampleData.push(rowArray)
        }
      }else{
        // API case
        sampleData = this.dataRows['data']
        fields = this.dataRows['fields']
      }
    }
    if (this.fileFormat != null) {
      this.fileFormat['name'] = this.formatName
      this.fileFormat['hasHeader'] = this.hasHeader
      this.fileFormat['separator'] = this.separator
    } else {
      this.dataRows = []
      this.fileFormat = {
        "name": this.formatName,
        "mappingObjects": this.mappingObjects,
        "sample": sampleData,
        "hasHeader": this.hasHeader,
        "separator":this.separator
      }
      this.fileFormat['fields'] = fields
    }
    this.fileFormat['serviceId'] = this.serviceId;
    this.fileFormat['externalApiGateway'] = this.externalApiGateway
    this.fileFormat['splitByYear'] = this.splitByYear;
    this.fileFormat['yearDateField'] = this.splitByYear ? this.yearDateField : null;
    this.fileFormat['flux'] = !!this.flux;
    this.fileFormat['specialColumns'] = this.specialColumns || [];

    this.serviceService.addFileFormat(this.fileFormat).subscribe(service => {
      this.dataFormatsAdded.emit(this.fileFormat);
      this.formatName = null;
      this.fileFormat = [];
      this.hasHeader = false;
      this.serviceService.updateService(service);
      this.closeWindow()
    }, error => {
      this.dataFormatsAdded.emit(this.fileFormat);
      this.errorMessage = 'ERRORS.' + error.code;
      this.openModal(this.informationTemplate);
    });
  }

  addNameToMapping(value, index) {
    this.mappingObjects[index].name = value;
  }

  addFormatToMapping(value, index) {
    this.mappingObjects[index]['format'] = value;
  }

  addCurrencyCodeToMapping(value, index) {
    if (value) this.mappingObjects[index]['currencyCode'] = value;
    else delete this.mappingObjects[index]['currencyCode'];
  }

  addAliasToMapping(value, index) {
    this.mappingObjects[index].alias = value;
  }

  addDescriptionToMapping(value, index) {
    this.mappingObjects[index].description = value;
  }

  clearFormData() {
    this.uploader.clearQueue();
    this.clearSelectedFile();
    this.dataRows = [];
  }

  removeFile(item) {
    this.clearFormData()
    item.remove();
  }

  closeWindow() {
    this.clearFormData()
    this.formatName = null;
    this.hasHeader = null;
    this.flux = false;
    this.specialColumns = [];
    this.modal.hide();
  }

  clearSelectedFile() {
    if (this.selectedFile)
      this.selectedFile.nativeElement.value = '';
  }

  isArray(item){
    return Array.isArray(item)
  }

  fetchMetaData() {
    this.fetching = true
    setTimeout(() => {
      this.separator = null
      this.fileFormat = null
      this.externalApiGatewayService.fetchMetaData$(this.externalApiGateway?.api?.id).subscribe(metaData => {
        try {
          // @ts-ignore
          this.dataRows = {data: metaData.data, fields: metaData.fields};
          this.mappingObjects = [];
          metaData.fields.forEach((item, index) => {
            this.mappingObjects.push({"column": index, "name": item, "alias": item, "description": ''})
          });
          this.fetching = false
        } catch (e) {
          console.error(`error during fetching data from API -> ${this.apiGateway.url}`, e)
        } finally {
          this.fetching = false
        }
      })
    }, 0)
  }
}
